/**
 * Call Context
 */
export enum CallContext {
  /**
   *  Caller and Callee have a relationship.
   */
  Relationship = 'relationship',

  /**
   *  Caller and Callee have an common affiliation.
   */
  Affiliation = 'affiliation',

  /**
   * Caller is a System Administrator.
   */
  SystemAdministration = 'system-administration',
}
